import React from "react";
import { TABLES } from "../../Utils/tableConst"
import { Table } from "../Table"

export const TableQuery8 = () => (
    <Table tableData={TABLES.QUERY_8} theme="horizontal" />
);
